<template>
  <section class="TcEventInscription">
    <div class="w-3/5 mx-auto py-5">
      <TcEventItem :event="event" hide_buttons="true" class="mb-5"></TcEventItem>
      <form id="EventInscriptionForm" action="#" class="form" @change="formChange" @submit="submitForm">
        <div class="form-section">
          <h3 class="flex items-center mb-3">
            <TcIcon icon="list-ul" class="h-6 w-6 mr-3"></TcIcon>
            <span class="font-semibold">Entradas</span>
          </h3>
          <div class="px-9 flex flex-col gap-3">
            <div>Tu entrada</div>
            <hr>
            <div>
              <div>
                <div class="flex w-full gap-3">
                  <div class="flex-1">
                    <label>Nombre</label>
                    <input required type="text" :disabled="$root.user || $root.external_user" v-model="name">
                  </div>
                  <div class="flex-1">
                    <label>Primer apellido</label>
                    <input required type="text" :disabled="$root.user || $root.external_user" v-model="surname1">
                  </div>
                  <div class="flex-1">
                    <label>Segundo apellido</label>
                    <input required type="text" :disabled="$root.user || $root.external_user" v-model="surname2">
                  </div>
                </div>
              </div>
              <div>
                <div class="flex w-full gap-3">
                  <div class="flex-1">
                    <label>Correo electrónico</label>
                    <input required type="email" :disabled="$root.user"  v-model="email">
                  </div>
                </div>
              </div>
              <div>
                <div class="flex w-full gap-3">
                  <div class="flex-1">
                    <label>NIF</label>
                    <input required type="text" :disabled="$root.user_profile || $root.external_user" v-model="nif">
                  </div>
                  <div class="flex-auto">
                    <label>Dirección</label>
                    <input required type="text" v-model="address">
                  </div>
                </div>
              </div>
              <div>
                <div class="flex w-full gap-3">
                  <div class="flex-1">
                    <label>Población</label>
                    <input required type="text" v-model="town">
                  </div>
                  <div class="flex-1">
                    <label>CP</label>
                    <input required type="text" v-model="postal_code">
                  </div>
                </div>
              </div>
            </div>
            <div v-if="event.check_bus">
              <div class="flex gap-1">
                <TcIcon icon="bus" class="h-5 w-5 text-gray-500"></TcIcon>
                <label class="flex">Quiero reservar guagua</label>
              </div>
              <div class="flex gap-3">
                <label class="block w-full">
                  <input class="hidden" type="radio" v-model="bus" :value="true">
                  <span class="flex gap-3"><b>Sí</b><b v-if="bus==true" class="ml-3 h-5 w-5">&#10004;</b></span>
                </label>
                <label class="block w-full">
                  <input class="hidden" type="radio" v-model="bus" :value="false">
                  <span class="flex gap-3"><b>No</b><b v-if="bus==false" class="ml-3 h-5 w-5">&#10004;</b></span>
                </label>
              </div>
            </div>
            <div v-if="event.allow_companions">
              <div v-if="companions.length == 0">
                <button type="button" @click="addCompanion">¿Quieres añadir acompañante? <small class="ml-2">(hasta {{event.companions_limit}})</small></button>
              </div>
              <div v-else>
                <div>Tus acompañantes <small>({{companions.length}} de {{event.companions_limit}})</small></div>
                <hr class="my-3">
                <table>
                  <thead>
                    <tr>
                      <th>Nombre</th><th>NIF</th><th></th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(companion,i) in companions" :key="companion.id">
                      <td><input type="text" required v-model="companion.name"></td>
                      <td><input type="text" required v-model="companion.nif"></td>
                      <td class="price">{{ event.companions_amount }}</td>
                      <td><span @click="removeCompanion(i)" class="action-remove">-</span></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="100%" class="pt-5">
                        <button v-if="companions.length<event.companions_limit" type="button" @click="addCompanion" class="bg-gray-500">Añadir otro acompañante</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- INVITADOS -->
        <div v-if="event.allow_guests" class="form-section">
          <div v-if="guests.length == 0" class="px-9">
            <button type="button" @click="addGuest">¿Quieres inscribir un invitado? <small class="ml-2">(hasta {{event.guests_limit}})</small></button>
          </div>
          <div v-else>
            <h3 class="flex items-center mb-3">
              <TcIcon icon="list-ul" class="h-6 w-6 mr-3"></TcIcon>
              <span class="font-semibold">Inscripción invitado</span>
            </h3>
            <div class="px-9">
              <div>Datos del invitado <small>({{guests.length}} de {{event.guests_limit}})</small></div>
              <hr class="my-3">
              <table>
                <thead>
                  <tr>
                    <th>Nombre / Nº colegiado</th><th>NIF</th><th></th><th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(guest,i) in guests" :key="guest.id">
                    <td><input required type="text" v-model="guest.name"></td>
                    <td><input required type="text" v-model="guest.nif"></td>
                    <td class="price">{{ event.guests_amount.strToEuro() }}</td>
                    <td><span @click="removeGuest(i)" class="action-remove">-</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="100%" class="pt-5">
                      <button v-if="guests.length<event.guests_limit" type="button" @click="addGuest" class="bg-gray-500">Añadir otro invitado</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <!-- NIÑOS -->
        <div v-if="event.allow_guests_children" class="form-section">
          <div v-if="guests_children.length == 0" class="px-9">
            <button type="button" @click="addGuestChildren">¿Quieres inscribir un niño invitado? <small class="ml-2">(hasta {{event.guests_children_limit}})</small></button>
          </div>
          <div v-else>
            <h3 class="flex items-center mb-3">
              <TcIcon icon="list-ul" class="h-6 w-6 mr-3"></TcIcon>
              <span class="font-semibold">Inscripción niño invitado</span>
            </h3>
            <div class="px-9">
              <div>Datos del niño invitado <small>({{guests_children.length}} de {{event.guests_children_limit}})</small></div>
              <hr class="my-3">
              <table>
                <thead>
                  <tr>
                    <th>Nombre</th><th>NIF</th><th></th><th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(children,i) in guests_children" :key="children.id">
                    <td><input required type="text" v-model="children.name"></td>
                    <td><input type="text" v-model="children.nif"></td>
                    <td class="price">{{ event.guests_children_amount.strToEuro() }}</td>
                    <td><span @click="removeGuestChildren(i)" class="action-remove">-</span></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="100%" class="pt-5">
                      <button v-if="guests_children.length<event.guests_children_limit" type="button" @click="addGuestChildren" class="bg-gray-500">Añadir otro niño invitado</button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <div v-if="eventQuestions.length" class="form-section">
          <h3 class="flex items-center mb-3">
            <TcIcon icon="list-ul" class="h-6 w-6 mr-3"></TcIcon>
            <span class="font-semibold">Preguntas del evento</span>
          </h3>
          <div class="px-9 flex flex-col gap-4">
            <div v-for="question in eventQuestions" :key="question.id" class="flex flex-col gap-2">
              <label class="font-bold">
                {{ question.name }}<sup v-if="question.required" class="required-mark">*</sup>
              </label>
              <input
                v-if="question.type === 'text'"
                type="text"
                class="w-full"
                v-model="questionAnswers[question.id]"
                :required="question.required"
                @input="updateFormState"
              >
              <select
                v-else-if="question.type === 'select'"
                class="w-full"
                v-model="questionAnswers[question.id]"
                :required="question.required"
                @change="updateFormState"
              >
                <option value="">Seleccione...</option>
                <option v-for="option in question.options" :key="option" :value="option">{{ option }}</option>
              </select>
              <div v-else-if="question.type === 'yesno'" class="flex gap-6">
                <label class="flex gap-2 items-center cursor-pointer">
                  <input
                    type="radio"
                    :name="'question_' + question.id"
                    value="0"
                    v-model="questionAnswers[question.id]"
                    @change="updateFormState"
                  >
                  <span>No</span>
                </label>
                <label class="flex gap-2 items-center cursor-pointer">
                  <input
                    type="radio"
                    :name="'question_' + question.id"
                    value="1"
                    v-model="questionAnswers[question.id]"
                    @change="updateFormState"
                  >
                  <span>Sí</span>
                </label>
              </div>
            </div>
            <div class="text-sm text-gray-600">Los campos marcados con * son obligatorios.</div>
          </div>
        </div>

        <div class="form-section">
          <div class="px-9 flex flex-col gap-3">
            <div @click="showLegal=!showLegal" class="cursor-pointer flex">
              <TcIcon v-if="showLegal" icon="chevron-up" class="h-6 w-9 pt-1"></TcIcon>
              <TcIcon v-else icon="chevron-down" class="h-6 w-9 pt-1"></TcIcon>
              <span class="font-semibold">
                Mostrar las condiciones del evento
              </span>
            </div>

            <div v-if="showLegal">
              <span class="font-semibold">
                CONSENTIMIENTO DEL ACOMPAÑANTE.
              </span>
            </div>
            <div v-if="showLegal">
              El colegiado al inscribir en esta actividad a un acompañante mayor de edad se hará responsable de contar con el consentimiento expreso previo del titular del dato para el conjunto de tratamientos que conlleva dicha actividad. Se abstendrá de realizar cualquier tratamiento de datos si no cuenta con dicho consentimiento. En todo caso, el COIICO no será del responsable de dicho tratamiento siendo en exclusiva del colegiado en este acto.
            </div>
            <div v-if="showLegal">
              <span class="font-semibold">
              MENORES DE EDAD.
              </span>
            </div>
            <div v-if="showLegal">
              El colegiado al inscribir en este evento a un acompañante menor de edad deberá:
              <div class="pl-9 my-3 flex flex-col">
                1. Contar con la patria potestad del menor.
                <br>
                2. En caso de no contar con dicho título habilitante, deberá contar con el consentimiento expreso de los padres/tutores legales del menor.
              </div>

              En ambos casos, deberán estar en disposición de acreditar dicha condición, bien mediante el libro de familia o mediante documento notarial o judicial que sostenga dicha acreditación. El COIICO denegará la participación en estos eventos si el solicitante no contara con la habilitación legal pertinente. En todo caso, el COIICO no será responsable de dicho tratamiento siendo en exclusiva del colegiado en este caso.
            </div>
            <div v-if="showLegal">
              <span class="font-semibold">
              CONSENTIMIENTO PARA ACCIONES PUBLICITARIAS Y MARKETING
              </span>
            </div>
            <div v-if="showLegal">
              La participación en este evento conlleva también su consentimiento expreso e inequívoco y el de las personas que le acompañan para poder realizar reportajes fotográficos, videos y emisión en directo de los eventos que este colegio celebre. También conlleva su consentimiento para poder dar divulgación a través de los canales de comunicación, redes sociales y página web del COIICO. Así como su publicación/divulgación a través de los canales de comunicación de los distintos patrocinadores cuando la actividad cuenten con patrocinador, para lo cual usted presta su consentimiento expreso e inequívoco.
            </div>
            <div v-if="showLegal">
              <span class="font-semibold">
              ALERGIAS
              </span>
            </div>
            <div v-if="showLegal">
              La participación en algunas actividades puedo conllevar almuerzos, cenas o participación en comidas conjuntas. Si usted o alguno de las personas a las que usted inscriba tiene algún tipo de alergias alimentarias, deberá comunicar el número de personas que lo son y tipología de la alergia a fin de comunicar.
            </div>
            <div v-if="showLegal">
              <span class="font-semibold">
              DESTINATARIOS
              </span>
            </div>
            <div v-if="showLegal">
              La participación es estos eventos puede conllevar la cesión y/o comunicación de sus datos personales así como de sus acompañantes a las entidades organizadoras o colaboradoras para el buen fin del mismo. Cada actividad indicará quién es el organizador del evento y, por tanto, quién será receptor de los datos en los casos que el acceso a los mismos estuviera motivado contractualmente.
            </div>

            <div class="font-semibold flex items-center gap-3">
              <input required type="checkbox" class="h-6 w-6" id="accept-conditions">
              <label for="accept-conditions">Acepto las condiciones del evento</label>
            </div>

            <div v-if="event.url_conditions" class="text-center">
              <a :href="event.url_conditions" target="_blank" class="text-primary">Condiciones específicas del servicio</a>
            </div>
          </div>
        </div>
        <div>
          <button type="button" class="flex gap-3"
            @click="setState('confirm')" :disabled="is_form_disabled">
            <TcIcon icon="ok" class="h-10 w-10"></TcIcon>
            <div>
              <span class="py-4 text-3xl">Confirmar preinscripción</span>
              <small v-if="is_form_disabled">(rellene todos los campos)</small>
            </div>
          </button>
        </div>
      </form>
    </div>
    <!-- ZONA DEL MODAL PARA RESULTADO DEL FETCH-POST -->
    <div v-if="state" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TcInscriptionConfirm
          v-if="state=='confirm'"
          :event="event"
          :guests="d_guests"
          :children="d_children"
          :companions="d_companions"
          :questions="confirmQuestions"
          :igic="$root.igic"
        ></TcInscriptionConfirm>
        <TcInscriptionSending v-else-if="state=='sending'"></TcInscriptionSending>
        <TcInscriptionSuccess v-else-if="state=='success'"></TcInscriptionSuccess>
        <TcInscriptionError v-else-if="state=='error'"></TcInscriptionError>
      </div>
    </div>
  </section>
</template>

<script>
import TcEventItem from './TcEventItem.vue';
import TcIcon from './TcIcon.vue';
import TcLegal from './TcLegal.vue';
import TcInscriptionConfirm from './TcInscriptionConfirm.vue'
import TcInscriptionSending from './TcInscriptionSending.vue'
import TcInscriptionSuccess from './TcInscriptionSuccess.vue'
import TcInscriptionError from './TcInscriptionError.vue'

const waiting = 300;
var wt_id = null;

function uuidv4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export default {
  name: 'TcEventInscription',
  props: ['event'],
  components: {
    TcEventItem,
    TcIcon,
    TcLegal,
    TcInscriptionConfirm,
    TcInscriptionSending,
    TcInscriptionSuccess,
    TcInscriptionError,
  },
  data () {
    return {
      name: '',
      surname1: '',
      surname2: '',
      nif: '',
      email: '',
      address: '',
      town: '',
      postal_code: '',
      bus: false,
      companions: [],
      guests: [],
      guests_children: [],
      is_form_disabled: true,
      error_msg: '',
      state: null,
      d_guests: null,
      d_children: null,
      d_companions: null,
      session_public: false,
      showLegal:false,
      eventQuestions: [],
      questionAnswers: {},
    }
  },
  computed: {
    confirmQuestions: function() {
      return this.eventQuestions.map((question) => ({
        name: question.name,
        value: this.formatQuestionAnswer(question),
      })).filter((item) => item.value !== '');
    },
    ticketQuestions: function() {
      if (!this.eventQuestions.length) {
        return null;
      }

      let questions = {};
      this.eventQuestions.forEach((question) => {
        questions[question.id] = this.questionAnswers[question.id];
      });
      return questions;
    },
    tickets: function() {
      let tot_com = 0
      let tot_gue = 0
      let tot_chi = 0
      let h_guests = {}
      let h_children = {}
      let h_companions = {}

      let member_name = '';
      let member_first_surname = '';
      let member_second_surname = '';
      let member_nif = '';

      this.companions.forEach((c) => {
        tot_com++;
        h_companions[tot_com.toString()] = {
          name: c.name,
          nif: c.nif,
        }
      })

      this.guests.forEach((g) => {
        tot_gue++;
        h_guests[tot_gue.toString()] = {
          name: g.name,
          nif: g.nif,
        }
      })

      this.guests_children.forEach((g) => {
        tot_chi++;
        h_children[tot_chi.toString()] = {
          name: g.name,
          nif: g.nif,
        }
      })

      let ticket = {
          "user_id" : this.$root.user ? this.$root.user.id.toString() : '',
          "event_id" : this.event.id.toString(),
          "member_number" : this.$root.user ? this.$root.user.number.toString() : '',
          "member_address" : this.address,
          "member_town" : this.town,
          "member_postal_code" : this.postal_code.toString(),
          "total_companions" : tot_com.toString(),
          "total_guests" : tot_gue.toString(),
          "total_guests_children" : tot_chi.toString(),
          "request_bus" : this.bus ? '1':'0',
          "observations" : "",
          "allergies" : "",
          "payer" : "1",
          "society_id" : "",
          "member_name" : this.name,
          "member_first_surname" : this.surname1,
          "member_second_surname" : this.surname2,
          "member_nif" : this.nif,
          "guests": h_guests,
          "guests_children": h_children,
          "companions": h_companions,
      };

      if (this.ticketQuestions) {
        ticket.questions = this.ticketQuestions;
      }

      return [ticket]
    },
    out: function() {
      return {
        access_token: this.$root.access_token,
        tickets: this.tickets,
        email: this.email,
      }
    },
  },
  mounted() {
    if(this.$root.user) {
      this.name = this.$root.user.user.name;
      this.surname1 = this.$root.user.user.surname1;
      this.surname2 = this.$root.user.user.surname2;
      this.email = this.$root.user.email;
    }
    if(this.$root.user_profile) {
      this.nif = this.$root.user_profile.nif;
      this.address = this.$root.user_profile.address;
      this.town = this.$root.user_profile.town;
      this.postal_code = this.$root.user_profile.postal_code;
    }
    else if(this.$root.external_user) {
      this.name = this.$root.external_user.name;
      this.surname1 = this.$root.external_user.surname1;
      this.surname2 = this.$root.external_user.surname2;
      this.nif = this.$root.external_user.dni;
    }
    this.session_public = this.$root.page=='login-public'; //Esto no me gusta nada... pero parece q es como se controla si es sessión publica
    this.loadEventQuestions();
  },
  methods: {
    loadEventQuestions: function() {
      if (this.event.questions && this.event.questions.length) {
        this.initQuestionAnswers(this.event.questions);
        return;
      }

      let url = `${this.$root.events_url()}/${this.event.id}`;
      if (this.$root.access_token) {
        url += `?access_token=${encodeURIComponent(this.$root.access_token)}`;
      }

      fetch(url)
        .then((response) => {
          const contentType = response.headers.get('content-type') || '';
          if (!contentType.includes('application/json')) {
            throw new Error('La API no devolvió JSON');
          }
          return response.json();
        })
        .then((json) => {
          this.initQuestionAnswers(json.questions || []);
        })
        .catch((error) => {
          console.error('Error cargando preguntas del evento', error);
        });
    },
    initQuestionAnswers: function(questions) {
      this.eventQuestions = questions;
      this.eventQuestions.forEach((question) => {
        const defaultValue = question.type === 'yesno' ? '0' : '';
        this.$set(this.questionAnswers, question.id, defaultValue);
      });
      this.updateFormState();
    },
    isFormValid: function(showReport) {
      const form = document.forms['EventInscriptionForm'];
      if (!form) {
        return false;
      }

      const formIsValid = showReport ? form.reportValidity() : form.checkValidity();
      return formIsValid && this.questionsAreValid();
    },
    updateFormState: function() {
      this.is_form_disabled = !this.isFormValid(false);
    },
    formatQuestionAnswer: function(question) {
      const value = this.questionAnswers[question.id];
      if (value === undefined || value === null) {
        return '';
      }
      if (question.type === 'yesno') {
        return value === '1' ? 'Sí' : 'No';
      }
      return String(value);
    },
    questionsAreValid: function() {
      for (let i = 0; i < this.eventQuestions.length; i++) {
        const question = this.eventQuestions[i];
        if (!question.required) {
          continue;
        }
        const value = this.questionAnswers[question.id];
        if (value === undefined || value === null || String(value).trim() === '') {
          return false;
        }
      }
      return true;
    },
    addCompanion: function () {
      //console.log('CLIck en addCompanion')
      this.companions.push({
        id: uuidv4(),
        type: 'adult',
        name: this.event.allow_anonymous ? 'Anónimo' : '',
        nif: this.event.allow_anonymous ? '-' : '',
      });
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    removeCompanion: function (i) {
      this.$delete(this.companions, i);
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    addGuest: function () {
      //console.log('CLIck en addGuest')
      this.guests.push({
        id: uuidv4(),
        name: this.event.allow_anonymous ? 'Anónimo' : '',
        nif: this.event.allow_anonymous ? '-' : '',
      });
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    removeGuest: function (i) {
      this.$delete(this.guests, i);
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    addGuestChildren: function () {
      //console.log('CLIck en addGuestChildren');
      this.guests_children.push({
        id: uuidv4(),
        name: this.event.allow_anonymous ? 'Anónimo' : '',
        nif: '',
      });
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    removeGuestChildren: function (i) {
      this.$delete(this.guests_children, i);
      clearTimeout(wt_id);
      wt_id = setTimeout(this.updateFormState, waiting);
    },
    confirmInscription: function () {
      const valid = this.isFormValid(true);
      this.is_form_disabled = !valid;
      return valid;
    },
    formChange: function () {
      this.updateFormState();
    },
    submitForm: function (ev) {
      //console.log('submitForm', ev.currentTarget);
      if(this.confirmInscription()) {
        let post_data = [
          this.event, this.bus, this.companions, this.guests
        ]
        console.log('TODO: ENVIANDO DATOS DEL EVENTO', post_data);
        return true;
      } else {
        //console.log('FORMULARIO NO VÁLIDO');
        this.is_form_disabled = true
        return false;
      }
    },
    setState: function(state) {
      if(state=='confirm') {
        let total_companions = 0
        let total_children = 0
        let total_guests = 0

        total_companions = this.companions.length;
        total_guests = this.guests.length;
        total_children = this.guests_children.length;

        this.d_companions = total_companions>0 ? {
          amount: total_companions,
          unit_price: parseFloat(this.event.companions_amount),
        } : null;

        this.d_children = total_children>0 ? {
          amount: total_children,
          unit_price: parseFloat(this.event.guests_children_amount),
        } : null;

        this.d_guests = total_guests>0 ? {
          amount: total_guests,
          unit_price: parseFloat(this.event.guests_amount),
        } : null;

      }
      this.state = state
    },
    setPage: function (page) {
      this.error_msg = ''
      this.state = false
      this.$parent.insc_event = null
      this.$root.setPage(page)
    },
    postEvent: function() {
      console.log('postEvent POSTING', this.out);
      this.error_msg = ''
      this.state = 'sending'
      let action = 'create_ticket';
      if ( this.session_public ) {
        action = 'save_ticket';
      }

      fetch('/post.php',{
        method: 'POST',
        body : JSON.stringify({
          access_token: this.$root.access_token,
          action: action,
          params: this.out,
        }),
      }).then(response => response.json())
      .then(json => {
        console.log('postEvent JSON', json)
        if(json.response && json.response===true) {
          this.state = 'success'
        } else {
          this.error_msg = 'No se ha podido realizar la subscripción, es posible que ya esté inscrito en este Evento.'
          this.state = 'error'
        }
      })
      .catch(error => {
        console.error('ERROR EN TcTest', error)
        this.error_msg = error
        this.state = 'error'
      })
    },
  }
}
</script>
